import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { isPublicRoute } from '../constants/publicRouteAllowlist';

const ROBOTS_META_NAME = 'robots';
const NOINDEX_CONTENT = 'noindex, nofollow';

export function useRouteNoindex(): void {
  const { pathname } = useLocation();

  useEffect(() => {
    if (isPublicRoute(pathname)) return undefined;

    const meta = document.createElement('meta');
    meta.name = ROBOTS_META_NAME;
    meta.content = NOINDEX_CONTENT;
    document.head.appendChild(meta);

    return () => {
      document.head.removeChild(meta);
    };
  }, [pathname]);
}
